import { UrlConstants } from "../url.constants";
export class ApiPropertyValuationprojectCycleAgriculturalActivityConstants {
    static URL = UrlConstants.API_V2 + "PropertyValuationprojectCycleAgricultureActivities";
    static FUNCTION_DELETE_MULTIPLE_GENERAL_VALUATION_RUN_AGRICULTURE_ACTIVITIES = "DeleteMultipleprojectCycleAgricultureActivities";
    static FUNCTION_UPLOAD_GENERAL_VALUATION_RUN_AGRICULTURE_ACTIVITIES = "UploadprojectCycleAgricultureActivities";
}
